export default __webpack_public_path__ + "static/media/logo-sicredi.f9969f00.png";